export enum ProductSiteRegionEnum {
    AMPLISEQ,
    THERMOFISHER,
    FISHERSCI_US,
    FISHERSCI_EU,
    FISHERSCI_CA
}
